<!-- 留言 -->
<template>
  <div class="judge-wrapper">
    <Card :padding="padding" class="judge-card" ref="judgeCard">
      <div slot="title" class="judge-title box">留言</div>
      <div slot="extra" class="extra" @click="refreshMessage()">
        <div class="icontext">
          <span class="iconfont icon-zhongzhi icon"></span>
          <span>刷新</span>
        </div>
      </div>
      <div class="body-wrapper">
        <Spin fix v-if="spinShow"></Spin>
        <div class="msgDiv" :style="{height:bodyHeight}" @scroll="judgeScrolls()" ref="judge">
          <div v-for="(val,index) in msgArr" :key="index" class="msgitem box">
            <!-- 头像 -->
            <div>
              <img
                :src="val.headPicUrl || '../../../assets/images/default.png'"
                alt
                class="headpicture"
              >
            </div>

            <!-- 内容 -->
            <div class="box_f1 judge-item">
              <div class="box" style="height:36px;line-height:36px;">
                <!-- 姓名 -->
                <div class="username box_f1">{{ val.userName }}</div>
                <!-- 点赞 数量 -->
                <div
                  class="iconfont icon-zan"
                  style="margin-right:10px;font-size:20px;color:#5e7da2;"
                ></div>
                <div>{{val.messageNumber}}</div>
              </div>
              <!-- 评论内容 -->
              <div class="msgboxs">{{ val.message }}</div>
              <!-- 评论图片 -->
              <div class="imgbox" v-if="val.imgList.length">
                <span v-for="(i,indeximg) in val.imgList" :key="indeximg">
                  <img :src="i" alt @click="modalShow2(indeximg,val.imgList)">
                </span>
              </div>
              <!-- 评论时间 -->
              <div class="timebox box">
                <div class="box_f1">{{val.createTime}}</div>
                <div style="color:#5e7da2;cursor:pointer;">
                  <span v-if="!val.children.content" @click="huifu(val)">回复</span>
                  <span @click="delComment(val.id)">删除</span>
                </div>
              </div>
              <!-- 回复 输入框 -->
              <div class v-if="val.isReplyFlag">
                <Input
                  type="textarea"
                  v-model="val.answerLocal"
                  placeholder="请输入..."
                  class="txt"
                  style="z-index:1"
                />
                <Button type="primary" size="small" class="cancel" @click="cancel(val)">取消</Button>
                <Button type="primary" size="small" class="reply" @click="reply(val)">确定</Button>
              </div>
              <!-- 作者回复 -->
              <div class="msgbox" v-if="val.children.id">
                <div class="htitle box">
                  <div class="zuozhe box_f1">作者回复</div>
                  <div
                    class="iconfont icon-zan"
                    style="margin-right:10px;font-size:20px;color:#5e7da2;"
                  ></div>
                  <div style="color:#999">{{val.children.likeNumber}}</div>
                </div>
                <!-- 作者回复内容 -->
                <div class="msgboxs">{{ val.children.content }}</div>
                <div class v-if="val.children.replyTime">
                  {{ val.children.replyTime }}
                  <span
                    @click="delComment(val.children.id)"
                    style="display:block;float:right;color:rgb(94, 125, 162);cursor:pointer;"
                  >删除</span>
                </div>
                <div class="msgtime" v-else></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
    <Modal v-model="modal" @on-ok="confirmDelReply">
      <p style="text-align:center;height:50px;line-height:50px;font-size:20px;">确定删除？</p>
    </Modal>

    <preview-img
      v-if="isShowImg"
      :imgArr="imgArr"
      :currentIndex="currentIndex"
      v-on:closePreview="closePreview"
    ></preview-img>
  </div>
</template>

<script>
var that;
/* 评论构造对象 */
function Comment(item) {
  this.id = item.id;
  this.userName = item.userName; // 用户姓名
  this.headPicUrl = item.headPicUrl; // 用户头像
  this.messageNumber = item.likeNumber; // 评论数量
  this.message = item.message; // 评论内容
  this.createTime = new Date(item.createTime).toLocaleString(); // 评论时间
  this.imgList = item.picUrlList || []; // 评论图片列表
  this.children = item.children.length
    ? item.children.map(child => {
        return {
          id: child.id,
          isLike: child.isLike, // 当前用户是否对回复点赞
          likeNumber: child.likeNumber, // 回复点赞数
          content: child.message, // 回复内容
          replyTime: new Date(child.createTime).toLocaleString() // 回复时间
        };
      })[0]
    : {}; // 只有一条回复
  this.answerLocal = ""; // 回复输入框内容
  this.isReplyFlag = false; // 回复输入框的开关
}
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import previewImg from "../../../components/previewImg";
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    id: null
  },
  components: {
    previewImg
  },
  data() {
    //这里存放数据
    return {
      padding: 0,
      bodyHeight: "",
      page: 1,
      rows: 30,
      msgArr: [],
      isReplyFlag: false,
      commentId: "",
      modal: false, // 删除提示框
      isAllJudge: false,
      isShowImg: false,
      imgArr: [],
      currentIndex: 0,
      spinShow: false // 加载中 显示
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    modalShow2(index, list) {
      //预览
      var _list = list.map((item, _index) => {
        return {
          id: _index,
          path: item,
          isHeight: 1
        };
      });
      var img1 = _list.slice(0, index);
      var img2 = _list.slice(index);
      this.currentIndex = index;
      this.imgArr = img2.concat(img1);
      this.isShowImg = true;
    },
    closePreview() {
      this.isShowImg = false;
    },
    // 滚动加载
    judgeScrolls() {
      if (!that.isAllJudge) {
        var offsetHeight = that.$refs.judge.offsetHeight,
          scrollHeight = that.$refs.judge.scrollHeight,
          scrollTop = that.$refs.judge.scrollTop,
          scrollBottom = offsetHeight + scrollTop;
        if (scrollBottom == scrollHeight) {
          that.page++;
          that.getMessage();
        }
      }
    },
    // 获取留言信息
    getMessage() {
      that._showSpin();
      that
        .$post(that.urlobj.getMessageList, {
          comeId: that.id,
          comeType: 6, //来源分类,0--社区，1--微社区，2--微支部，3--企业,4--社区公告，5--学习，6--活动，7--投票,
          pageNum: that.page,
          pageSize: that.rows
        })
        .then(res => {
          that._hideSpin();
          if (res.rows.length < that.rows) {
            that.isAllJudge = true;
          }
          that.msgArr = [
            ...that.msgArr,
            ...res.rows.map(item => new Comment(item))
          ];
        });
    },
    /* 刷新列表 */
    refreshMessage() {
      that._showSpin();
      that
        .$post(that.urlobj.getMessageList, {
          comeId: that.id,
          comeType: 6, //来源分类,0--社区，1--微社区，2--微支部，3--企业,4--社区公告，5--学习，6--活动，7--投票,
          pageNum: 1,
          pageSize: that.page * that.rows
        })
        .then(res => {
          that._hideSpin();
          if (res.rows.length < that.rows) {
            that.isAllJudge = true;
          }
          that.msgArr = res.rows.map(item => new Comment(item));
        });
    },
    // 点击开始回复 弹出回复输入框
    huifu(val) {
      this.$set(val, "isReplyFlag", true);
    },
    // 取消回复
    cancel(val) {
      this.$set(val, "isReplyFlag", false);
    },
    /* 进行作者回复 */
    reply(val) {
      if (!val.answerLocal) {
        this.$Message.warning("请输入回复内容!");
        this.$set(val, "isReplyFlag", false);
        return;
      }
      that._showSpin();
      this.$set(val, "isReplyFlag", false);
      var url = this.urlobj.saveMessage;
      this.$post(url, {
        comeId: that.id,
        comeType: 6,
        parentId: val.id,
        message: val.answerLocal
      }).then(function(res) {
        that._hideSpin();
        if (res.isSucceed) {
          that.refreshMessage(); // 刷新 避免并发
        }
      });
    },
    // 显示删除 弹窗
    delComment(id) {
      this.modal = true;
      this.commentId = id;
    },
    // 确认删除回复
    confirmDelReply() {
      that._showSpin();
      var url = that.urlobj.delMessage;
      that
        .$post(url, {
          id: that.commentId
        })
        .then(function(res) {
          that._hideSpin();
          if (res.isSucceed) {
            that.refreshMessage(); // 刷新 避免并发
          }
        });
    },
    // 显示loading
    _showSpin() {
      that.spinShow = true;
    },
    // 隐藏loading
    _hideSpin() {
      that.spinShow = false;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    that = this;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.bodyHeight =
      parseInt(this.$refs.judgeCard.$el.offsetHeight * 0.8) + "px";
    that.getMessage();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.judge-wrapper {
  width: 100%;
  height: 100%;
}
.judge-card {
  height: 100%;
}
.extra {
  height: 28px;
  line-height: 28px;
  cursor: pointer;
}
.judge-title {
  height: 28px;
  line-height: 28px;
}
// card-body
.body-wrapper {
  position: relative;
}
.msgDiv {
  overflow-x: hidden;
  overflow-y: scroll;
}
.msgDiv::-webkit-scrollbar {
  width: 0;
}

.msgitem {
  padding: 20px;
  width: 100%;
  color: #999;
  font-size: 14px;
  .headpicture {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    margin-right: 20px;
  }
  .username {
    color: #444;
    font-size: 18px;
  }
  .timebox {
    color: #c6cbd1;
    font-size: 14px;
    padding-top: 20px;
  }
  .timebox span {
    color: #5e7da2;
    margin-left: 10px;
    cursor: pointer;
  }
}
.judge-item {
  min-width: 250px;
  padding-bottom: 10px;
}
.msgbox {
  width: 100%;
  height: auto;
  margin-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  font-size: 14px;
  color: #999;
}
.htitle {
  color: #333;
  padding-left: 12px;
  margin: 20px 0;
  height: 14px;
  line-height: 14px;
  border-left: 2px solid #ff7b46;
}
.msgboxs {
  margin-bottom: 10px;
  margin-top: 10px;
  word-wrap: break-word;
  word-break: break-all;
}
.reply,
.cancel {
  float: right;
  margin-top: 5px;
  margin-left: 5px;
}
.imgbox {
  padding: 5px;
}
.imgbox img {
  width: 50px;
  height: 50px;
  /*border-radius:50%;*/
  margin-right: 12px;
}
.icon {
  margin-right: 2px;
}

.icontext span {
  font-size: 14px;
  color: #67799d;
}
.icontext:last-child {
  margin-left: 10px;
}
.icon span {
  font-size: 16px;
}
</style>

